import { ButtonLink, ButtonLinkAsSimpleText } from '~/prix/react/components/button'
import categories, { sentinelVariableCategorySections } from '../categories'
import styled from 'styled-components'
import { useMemo, useState } from 'react'
import { CategoryButtonsDropdown } from './viewSelectModalVariable.categoryButtons'
import { Variable } from '~/packages/general/variable/variables.typing'

const Wrapper = styled.div`
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  scrollbar-gutter: stable;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    padding: ${({ theme }) => theme.padding(0.3)} 0;
  }

  h4 {
    display: none;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      display: flex;
      font-weight: bold;
      color: #363636;
      font-size: 1rem;
      user-select: none;
      margin: 1.5rem 0 0 1rem;
    }
  }
  .buttons-filter {
    display: none;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      display: flex;
      justify-content: end;
    }
  }

  .menu {
    display: flex;
    flex-direction: column;
    border-right: 1px solid ${({ theme }) => theme.colors.lightGrey};
    padding: ${({ theme }) => theme.padding(1)};
    min-height: 100%;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      width: 100%;
      height: fit-content;
      border-right: none;
      box-shadow: none;
      overflow-y: auto;
    }

    h5 {
      font-weight: 500;
      font-size: 0.8rem;
      text-transform: uppercase;
      margin: 1rem 0;
      color: ${({ theme }) => theme.colors.darkGrey};
      user-select: none;
      letter-spacing: 1px;
    }

    button {
      border: none;
      outline: none;
      background-color: transparent;
      cursor: pointer;
      font-size: 0.9rem;
      padding: 0.5rem;
      text-align: left;
      color: ${({ theme }) => theme.colors.darkGrey};
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    button:not(.button-active-category):hover {
      background-color: ${({ theme }) => theme.colors.lightGrey};
      color: ${({ theme }) => theme.colors.darkText};
    }

    .button-active-category {
      background-color: ${({ theme }) => theme.colors.primary};
      color: white;
    }

    .category-item-wrapper {
      display: flex;
      flex-direction: column;
    }

    .nested-toggle {
      display: inline-flex;
      align-items: center;
      margin-left: ${({ theme }) => theme.padding(0.3)};
    }

    .nested-category-list {
      display: flex;
      flex-direction: column;
      margin-left: ${({ theme }) => theme.padding(0.6)};
      margin-top: ${({ theme }) => theme.padding(0.2)};
    }

    .nested-category-button {
      font-size: 0.82rem;
      padding-left: ${({ theme }) => theme.padding(1)};
    }
  }
`

interface CategoryInfo {
  key: string
  title: string
  sectorKey: string
  parentKey?: string
  childrenKeys?: string[]
  defaultChildKey?: string
}

interface WrapperFiltersProps {
  currentCategory: typeof categories
  handleClick: (info: { key: string; title: string; sectorKey: string }) => void
  categoriesInfo: CategoryInfo[]
  setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>
  isMobile: boolean
  isModalOpen: boolean
  variables?: Variable[]
}
const WrapperFilters = ({
  categoriesInfo,
  currentCategory,
  handleClick,
  setIsFilterOpen,
  isMobile,
  isModalOpen,
  variables,
}: WrapperFiltersProps) => {
  const [selectedCategory, setSelectedCategory] = useState<typeof categories>(currentCategory)

  const staticCategories = sentinelVariableCategorySections.map(section => ({
    key: section.key,
    name: section.title,
    categoryKeys: [...section.categoryKeys],
  }))

  const highlightedCategoryKeys = useMemo(() => {
    //TODO DESTAQUE DE USUÁRIO Remover esse colchete reativa o stars nas categorias do menu.
    return []
  }, [variables])

  const handleSelectCategory = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    info: { key: string; title: string; sectorKey: string },
  ) => {
    event.preventDefault()
    event.stopPropagation()
    const newSelectedCategory = {
      [info.key]: {
        title: info.title,
        sectorKey: info.sectorKey,
      },
    }
    setSelectedCategory(newSelectedCategory)
    if (!isMobile) confirmCategory(event, newSelectedCategory)
  }

  const confirmCategory = (
    event: React.MouseEvent<Element, MouseEvent>,
    selectedCategory: typeof categories,
  ) => {
    event.preventDefault()
    handleClick({
      key: Object.keys(selectedCategory)[0],
      title: selectedCategory[Object.keys(selectedCategory)[0]].title,
      sectorKey: selectedCategory[Object.keys(selectedCategory)[0]].sectorKey,
    })
    setIsFilterOpen(false)
  }

  return (
    <Wrapper>
      <div className='menu'>
        {staticCategories.map(category => {
          return (
            <CategoryButtonsDropdown
              key={category.key}
              categoryKey={category.key}
              categoryName={category.name}
              categoryKeys={category.categoryKeys}
              selectedCategory={selectedCategory}
              categoriesInfo={categoriesInfo}
              handleSelectCategory={handleSelectCategory}
              isModalOpen={isModalOpen}
              highlightedCategoryKeys={highlightedCategoryKeys}
            />
          )
        })}
      </div>

      <div className='buttons-filter'>
        <ButtonLinkAsSimpleText onClick={() => setIsFilterOpen(false)}>
          Voltar
        </ButtonLinkAsSimpleText>
        {/* <ButtonLink
          style={{ marginRight: '7px' }}
          onClick={event => confirmCategory(event, selectedCategory)}
        >
          Filtrar
        </ButtonLink> */}
      </div>
    </Wrapper>
  )
}

export default WrapperFilters
